import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys } from "../../utils/AppUtils";
import {
  getLeaderBoardClear,
  getLeaderBoardReq,
} from "../../redux/user/actions";
import _ from "lodash";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import {
  shareImage,
  shareImageResponseClear,
} from "../../redux/events/actions";
import CONFIG from "../../utils/config";
import Loader from "../Loader/Loader";
import OfficeSelectComp from "./OfficeSelectComp";
import { useNavigate } from "react-router-dom";

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <span
    className="shar-btn"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </span>
));
const LeaderBoardComp = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const leaderBoardDataTestRes = useSelector((state) => state.user.leaderBoard);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const imageUrlRes = useSelector((state) => state.events.shareImageRes);
  const userRole = useSelector((state) => state.user.role);

  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [lastUpdateTime, setLastUpdateTime] = useState("");
  const [clickedShareBtn, setClickedShareBtn] = useState(0);

  const [fbTagetUrl, setfbTagetUrl] = useState();
  const [linkedinTargetUrl, setlinkedinTargetUrl] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [selectedOfficeList, setSelectedOfficeList] = useState([]);
  const [tabKey, setTabKey] = useState("last_month");

  useEffect(() => {
    getLeaderBoardData();
  }, [tabKey]);

  useEffect(() => {
    // console.log('leaderBoardDataTestRes: ',leaderBoardDataTestRes);
    if (!_.isEmpty(leaderBoardDataTestRes)) {
      setIsLoading(false);
      if (leaderBoardDataTestRes?.status === "success") {
        setLeaderBoardData(leaderBoardDataTestRes?.payload?.payload?.list);
        setLastUpdateTime(
          moment
            .unix(leaderBoardDataTestRes?.payload?.payload?.last_updated)
            .format("Do MMMM YYYY, h:mm A")
        );
        dispatch(getLeaderBoardClear());
      } else {
        setLeaderBoardData([]);
      }
    }
  }, [leaderBoardDataTestRes]);

  let selectedOffice = [];
  selectedOfficeList.forEach((element) => {
    selectedOffice.push(element.office_id);
  });

  //get leader board
  const getLeaderBoardData = () => {
    setIsLoading(true);
    dispatch(
      getLeaderBoardReq({
        module: "leaderBoard",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          user_id: localStorage.getItem(SessionKeys.USER_ID),
          office_id: selectedOffice,
          tab: tabKey,
        },
      })
    );
  };

  useEffect(() => {
    if (clickedShareBtn > 0) {
      getBlobForAllEvents();
    }
  }, [clickedShareBtn]);

  const getBlobForAllEvents = () => {
    console.log("shareJson: ", leaderBoardData);
    let reqArr = [];
    for (let i = 0; i < leaderBoardData.length; i++) {
      const item = leaderBoardData[i];
      let tempObj = {
        name: item?.name,
        rank: item.rank,
        office: item.office,
        score: item?.score,
        profile: item.profile,
        is_me: item.is_me,
      };
      reqArr.push(tempObj);

      // if (i === 8) {
      //   break;
      // }
    }

    setIsLoading(true);
    dispatch(
      shareImage({
        module: "shareImageLeaderBoard",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          content_top: reqArr?.slice(0, 3),
          content_table:
            reqArr.length > 3 ? reqArr?.slice(3, reqArr.length) : [],
        },
      })
    );
  };

  useEffect(() => {
    if (!_.isEmpty(imageUrlRes)) {
      setIsLoading(false);
      if (imageUrlRes?.status === "success") {
        console.log("respo", imageUrlRes);
        setfbTagetUrl(imageUrlRes?.payload?.payload?.fb_target_url);
        setlinkedinTargetUrl(
          imageUrlRes?.payload?.payload?.linkedin_target_url
        );

        let pdfUrl =
          CONFIG.API_URL_BROKER_ADMIN + imageUrlRes?.payload?.payload?.pdf_url;
        let imgUrl =
          CONFIG.API_URL_BROKER_ADMIN + imageUrlRes?.payload?.payload?.data;
        let fbUrl = imageUrlRes?.payload?.payload?.fb_target_url;
        let linkedInUrl = imageUrlRes?.payload?.payload?.linkedin_target_url;
        console.log("responseShare", clickedShareBtn);

        let shareUrl =
          clickedShareBtn === 1
            ? pdfUrl
            : clickedShareBtn === 2
            ? imgUrl
            : clickedShareBtn === 3
            ? fbUrl
            : clickedShareBtn === 4
            ? linkedInUrl
            : "";

        if (clickedShareBtn > 0) {
          window.open(shareUrl, "_blank");
          setClickedShareBtn(0);
          dispatch(shareImageResponseClear());
        }
      }
    }
  }, [imageUrlRes, dispatch]);

  return (
    <>
      <Loader start={isLoading} />
      <div className="row">
        {
          <div className="col-md-12 mb-3">
            <h2 className="requesthead d-flex gap-2 align-items-center">
              <span
                className="back-btn cursor-pointer"
                style={{}}
                onClick={() => {
                  navigate("/");
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  width="30"
                  height="30"
                  fill="none"
                >
                  <g transform="scale(-1, 1) translate(-20, 0)">
                    <path
                      d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                      stroke="#6941C6"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                </svg>
              </span>
              Leaderboard
              {userRole === "manager" && (
                <Dropdown className="social-share">
                  <Dropdown.Toggle
                    as={CustomToggle}
                    id="dropdown-custom-components"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="rgba(0,0,0,1)"
                    >
                      <path d="M13.1202 17.0228L8.92129 14.7324C8.19135 15.5125 7.15261 16 6 16C3.79086 16 2 14.2091 2 12C2 9.79086 3.79086 8 6 8C7.15255 8 8.19125 8.48746 8.92118 9.26746L13.1202 6.97713C13.0417 6.66441 13 6.33707 13 6C13 3.79086 14.7909 2 17 2C19.2091 2 21 3.79086 21 6C21 8.20914 19.2091 10 17 10C15.8474 10 14.8087 9.51251 14.0787 8.73246L9.87977 11.0228C9.9583 11.3355 10 11.6629 10 12C10 12.3371 9.95831 12.6644 9.87981 12.9771L14.0788 15.2675C14.8087 14.4875 15.8474 14 17 14C19.2091 14 21 15.7909 21 18C21 20.2091 19.2091 22 17 22C14.7909 22 13 20.2091 13 18C13 17.6629 13.0417 17.3355 13.1202 17.0228ZM6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14ZM17 8C18.1046 8 19 7.10457 19 6C19 4.89543 18.1046 4 17 4C15.8954 4 15 4.89543 15 6C15 7.10457 15.8954 8 17 8ZM17 20C18.1046 20 19 19.1046 19 18C19 16.8954 18.1046 16 17 16C15.8954 16 15 16.8954 15 18C15 19.1046 15.8954 20 17 20Z"></path>
                    </svg>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <div className="sm_list">
                      <div
                        className="linkedin cursor-pointer"
                        onClick={() => {
                          setClickedShareBtn(1);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                        >
                          <circle
                            cx="15"
                            cy="15"
                            r="15"
                            fill="#000000"
                            data-name="Ellipse 180"
                          ></circle>
                          <circle
                            cx="13"
                            cy="13"
                            r="13"
                            fill="#fff"
                            data-name="Ellipse 181"
                            transform="translate(2 2)"
                          ></circle>
                          <path
                            fill="#000000"
                            d="M5.684 8a3.015 3.015 0 01-.062-1.466c.262.003.237 1.157.062 1.466zm-.053 1.478a14.42 14.42 0 01-.887 1.959 11.507 11.507 0 011.966-.684 4.048 4.048 0 01-1.079-1.275zm-2.941 3.9c0 .025.412-.169 1.091-1.256a4.319 4.319 0 00-1.09 1.256zM7.75 5H12v10.25a.748.748 0 01-.75.75H.75a.748.748 0 01-.75-.75V.75A.748.748 0 01.75 0H7v4.25a.752.752 0 00.75.75zm-.25 5.369a3.136 3.136 0 01-1.334-1.681 4.492 4.492 0 00.194-2.006.783.783 0 00-1.494-.213 5.2 5.2 0 00.253 2.406 29.344 29.344 0 01-1.275 2.681h-.006c-.847.434-2.3 1.391-1.7 2.125a.971.971 0 00.668.319c.559 0 1.116-.562 1.909-1.931a17.813 17.813 0 012.469-.725 4.736 4.736 0 002 .609.809.809 0 00.616-1.359c-.434-.425-1.7-.3-2.3-.225zm4.281-7.087L8.719.219A.749.749 0 008.188 0H8v4h4v-.191a.748.748 0 00-.219-.528zm-2.315 7.977c.128-.084-.078-.372-1.338-.281 1.16.494 1.338.281 1.338.281z"
                            data-name="Icon awesome-file-pdf"
                            transform="translate(9 7)"
                          ></path>
                        </svg>
                      </div>
                      <div
                        className="linkedin cursor-pointer"
                        onClick={() => {
                          setClickedShareBtn(2);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                        >
                          <circle
                            id="Ellipse_57"
                            data-name="Ellipse 57"
                            cx="15"
                            cy="15"
                            r="15"
                            fill="#000000"
                          ></circle>
                          <circle
                            id="Ellipse_179"
                            data-name="Ellipse 179"
                            cx="13"
                            cy="13"
                            r="13"
                            transform="translate(2 2)"
                            fill="#fff"
                          ></circle>
                          <g
                            id="surface1"
                            className="imageuploadsv"
                            transform="translate(5 4.586)"
                          >
                            <path
                              fill="#000000"
                              stroke="#000000"
                              d="M 3.332031 3.332031 C 2.421875 3.332031 1.667969 4.089844 1.667969 5 L 1.667969 15 C 1.667969 15.910156 2.421875 16.667969 3.332031 16.667969 L 16.667969 16.667969 C 17.578125 16.667969 18.332031 15.910156 18.332031 15 L 18.332031 5 C 18.332031 4.089844 17.578125 3.332031 16.667969 3.332031 Z M 3.332031 5 L 16.667969 5 L 16.667969 15 L 3.332031 15 Z M 12.082031 9.167969 L 9.167969 12.5 L 7.082031 10.417969 L 4.816406 13.332031 L 15.207031 13.332031 Z M 12.082031 9.167969 "
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div
                        className="facebook cursor-pointer"
                        onClick={() => {
                          setClickedShareBtn(3);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="facebook"
                          data-name="facebook"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                        >
                          <circle
                            id="Ellipse_198"
                            data-name="Ellipse 198"
                            cx="15"
                            cy="15"
                            r="15"
                            fill="#000000"
                          ></circle>
                          <circle
                            id="Ellipse_199"
                            data-name="Ellipse 199"
                            cx="13"
                            cy="13"
                            r="13"
                            transform="translate(2 2)"
                            fill="#fff"
                            className="fillwhite"
                          ></circle>
                          <path
                            id="Icon_awesome-facebook-f"
                            data-name="Icon awesome-facebook-f"
                            d="M8.9,8.2l.4-2.638H6.778V3.849A1.319,1.319,0,0,1,8.265,2.424H9.415V.178A14.031,14.031,0,0,0,7.373,0,3.22,3.22,0,0,0,3.926,3.55V5.56H1.609V8.2H3.926v6.376H6.778V8.2Z"
                            transform="translate(9.487 7.713)"
                            fill="#000000"
                          ></path>
                        </svg>
                      </div>
                      <div
                        className="linkedin cursor-pointer"
                        onClick={() => {
                          setClickedShareBtn(4);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="linkedin"
                          data-name="linkedin"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                        >
                          <circle
                            id="Ellipse_57"
                            data-name="Ellipse 57"
                            cx="15"
                            cy="15"
                            r="15"
                            fill="#000000"
                          ></circle>
                          <circle
                            id="Ellipse_179"
                            data-name="Ellipse 179"
                            cx="13"
                            cy="13"
                            r="13"
                            transform="translate(2 2)"
                            fill="#fff"
                            className="fillwhite"
                          ></circle>
                          <path
                            id="Icon_awesome-linkedin-in"
                            data-name="Icon awesome-linkedin-in"
                            d="M2.781,12.424H.205V4.13H2.781ZM1.492,3A1.5,1.5,0,1,1,2.983,1.492,1.5,1.5,0,0,1,1.492,3Zm10.929,9.426H9.851V8.386c0-.962-.019-2.2-1.339-2.2-1.339,0-1.544,1.045-1.544,2.127v4.107H4.394V4.13h2.47V5.261H6.9A2.706,2.706,0,0,1,9.338,3.922c2.607,0,3.086,1.717,3.086,3.946v4.556Z"
                            transform="translate(8.788 8.789)"
                            fill="#000000"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </h2>
          </div>
        }

        <div className="col-md-12 mb-2">
            <h2 className="requesthead d-flex gap-2 align-items-center">
              <span className="back-btn" >
                  Top Trained Agents
              </span>
            </h2>
        </div>  

        <div className="my_courses">
          <div className="lw-filters filters-leaderboard">
            <OfficeSelectComp
              selectedOfficeList={selectedOfficeList}
              setSelectedOfficeList={setSelectedOfficeList}
              getLeaderBoardData={getLeaderBoardData}
            />
          </div>
          <Tabs
            defaultActiveKey="last_month"
            id="justify-tab-example"
            className="mb-3"
            justify
            onSelect={(k) => {
              console.log("selectKey: ", k);
              setTabKey(k);
            }}
          >
            <Tab eventKey="last_week" title="Last Week"></Tab>
            <Tab eventKey="last_month" title="Last Month"></Tab>
            <Tab eventKey="overall" title="Overall"></Tab>
          </Tabs>
          <div className="tab-leader-content">
            {leaderBoardData.length > 0 ? (
              <div className="row">
                {leaderBoardData.map((item, index) => {
                  return (
                    index < 3 && (
                      <div className="col-md-4 mb-4 mnbg">
                        <div
                          className="course_management"
                          style={{ cursor: "default" }}
                        >
                          <div className="d-flex gap-3 w-100 leaderbox align-items-start">
                            <div className="img-box-leader">
                              <img
                                src={
                                  _.isEmpty(item?.profile)
                                    ? "/images/avatar.png"
                                    : item?.profile
                                }
                                alt="user"
                              />
                            </div>
                            <div className="foldertex">
                              <h5 className="mb-2 leadername">{item?.name}</h5>
                              {false && (
                                <span className="d-flex align-items-center gap-2">
                                  <svg
                                    width="17"
                                    height="19"
                                    viewBox="0 0 17 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_1907_109039)">
                                      <path
                                        d="M2.96924 15.8691C2.69678 16.001 2.37012 15.8867 2.23975 15.6143C2.10791 15.3418 2.22217 15.0151 2.49463 14.8848C3.15381 14.5669 3.81006 14.3047 4.46191 14.0981C5.11816 13.8901 5.77881 13.7378 6.44385 13.6411C6.78223 13.5913 7.1206 13.5576 7.45898 13.5371V12.9951L5.84912 11.7969C5.79053 11.7192 5.74805 11.6313 5.72314 11.5391H3.17578V11.5361C2.62793 11.5361 2.13281 11.3149 1.77539 10.9575C1.41797 10.6001 1.19678 10.105 1.19678 9.55713H1.19385V7.16064H0.681152V7.15771C0.493652 7.15771 0.322266 7.08154 0.200684 6.9585C0.0791016 6.83691 0.00439453 6.66846 0.00292969 6.48242L0 6.48096H0.00146484V5.92139C0.00146484 5.73242 0.0776367 5.5625 0.200684 5.44092C0.322266 5.31934 0.490723 5.24463 0.676758 5.24316L0.678223 5.2417H3.12305V5.24316C3.31201 5.24316 3.48193 5.31934 3.60352 5.44092V5.44238C3.7251 5.56397 3.7998 5.73242 3.80127 5.91846L3.80273 5.92139H3.80127V6.48096C3.80127 6.66992 3.7251 6.84131 3.60352 6.96143C3.48193 7.08301 3.31348 7.15771 3.12744 7.15771L3.12451 7.16064H2.47119V9.55566H2.46826C2.46826 9.74609 2.54883 9.92188 2.67773 10.0522C2.80664 10.1812 2.98242 10.2617 3.17432 10.2617V10.2588H3.59326V9.10303C3.59326 8.6123 4.02539 8.21094 4.55127 8.21094H11.5869C12.1143 8.21094 12.5449 8.6123 12.5449 9.10303V10.2588H12.9639V10.2617C13.1543 10.2617 13.3315 10.1812 13.4604 10.0522C13.5894 9.92334 13.6699 9.74609 13.6699 9.55566H13.667V7.16064H13.248V7.15771C13.0605 7.15771 12.8906 7.08154 12.7676 6.9585C12.646 6.83691 12.5713 6.66846 12.5698 6.48242L12.5684 6.47949H12.5698V5.91992C12.5698 5.73096 12.6475 5.56104 12.769 5.43945C12.8906 5.31787 13.0591 5.24316 13.2451 5.2417L13.248 5.24023H15.6929V5.2417C15.8818 5.2417 16.0518 5.31787 16.1733 5.43945V5.44092C16.2949 5.5625 16.3696 5.73096 16.3711 5.91699L16.3726 5.91992H16.3711V6.47949C16.3711 6.66699 16.2949 6.83838 16.1719 6.95996C16.0503 7.08154 15.8818 7.15625 15.6958 7.15625L15.6943 7.15918H14.9473V9.5542H14.9443C14.9443 10.1021 14.7231 10.5972 14.3657 10.9546C14.0083 11.312 13.5132 11.5332 12.9653 11.5332V11.5361H10.4824C10.4575 11.6489 10.4077 11.7559 10.3359 11.8481L8.73633 12.9395V13.5327C9.17871 13.5562 9.61963 13.606 10.062 13.6821C11.2661 13.8887 12.4658 14.2871 13.6641 14.8833C13.9351 15.0181 14.0449 15.3462 13.9102 15.6172C13.7754 15.8882 13.4473 15.998 13.1763 15.8633C12.0747 15.314 10.9746 14.9478 9.87891 14.7603C9.49805 14.6958 9.11719 14.6519 8.73779 14.6284V15.6787C8.73779 16.0317 8.45215 16.3174 8.09912 16.3174C7.74609 16.3174 7.46045 16.0317 7.46045 15.6787V14.6313C7.17334 14.6489 6.88623 14.6797 6.59912 14.7207C6.00146 14.8071 5.39795 14.9478 4.79297 15.1396C4.18066 15.3359 3.57275 15.5776 2.96924 15.8691ZM4.07812 0.5H12.0615C12.3267 0.5 12.5654 0.718262 12.542 0.980469L11.8828 7.18701C11.855 7.44922 11.666 7.66748 11.4023 7.66748H4.76953C4.50586 7.66748 4.3125 7.45068 4.28906 7.18701L3.59766 0.980469C3.57422 0.718262 3.81445 0.5 4.07812 0.5ZM13.4707 16.6279C13.9878 16.6279 14.4067 17.0469 14.4067 17.564C14.4067 18.0811 13.9878 18.5 13.4707 18.5C12.9536 18.5 12.5347 18.0811 12.5347 17.564C12.5347 17.0469 12.9536 16.6279 13.4707 16.6279ZM8.12695 16.6279C8.64404 16.6279 9.06299 17.0469 9.06299 17.564C9.06299 18.0811 8.64404 18.5 8.12695 18.5C7.60986 18.5 7.19092 18.0811 7.19092 17.564C7.19092 17.0469 7.60986 16.6279 8.12695 16.6279ZM2.7832 16.6279C3.30029 16.6279 3.71924 17.0469 3.71924 17.564C3.71924 18.0811 3.30029 18.5 2.7832 18.5C2.26611 18.5 1.84717 18.0811 1.84717 17.564C1.84717 17.0469 2.26611 16.6279 2.7832 16.6279Z"
                                        fill="#4F4C55"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1907_109039">
                                        <rect
                                          width="16.374"
                                          height="18"
                                          fill="white"
                                          transform="translate(0 0.5)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>

                                  {item?.role ? item?.role : "-"}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="d-flex grow-1 align-items-start gap-3 justify-content-between">
                            <div className="dt-icons">
                              <svg
                                width="20"
                                height="21"
                                viewBox="0 0 20 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1907_109049)">
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M10 0.5L12.2005 2.28874L15 1.83952L16.0107 4.48926L18.6605 5.5L18.2113 8.29948L20 10.5L18.2113 12.7005L18.6605 15.5L16.0107 16.5107L15 19.1605L12.2005 18.7113L10 20.5L7.79948 18.7113L5 19.1605L3.98926 16.5107L1.33952 15.5L1.78874 12.7005L0 10.5L1.78874 8.29948L1.33952 5.5L3.98926 4.48926L5 1.83952L7.79948 2.28874L10 0.5ZM10 6.93555L11.0319 9.45671L13.7484 9.65853L11.6699 11.4196L12.3177 14.0661L10.0016 12.6322L7.68555 14.0661L8.33333 11.4196L6.25163 9.65853L8.9681 9.45671L10 6.93555ZM10 4.84733C13.1217 4.84733 15.6527 7.37826 15.6527 10.5C15.6527 13.6217 13.1217 16.1527 10 16.1527C6.87826 16.1527 4.34733 13.6217 4.34733 10.5C4.34733 7.37826 6.87826 4.84733 10 4.84733Z"
                                    fill="#6A6572"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1907_109049">
                                    <rect
                                      width="20"
                                      height="20"
                                      fill="white"
                                      transform="translate(0 0.5)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="dt-text">{item?.rank}</span>
                            </div>
                            <div className="dt-icons justify-content-end dt-meter">
                              <svg
                                className="meter"
                                width="37"
                                height="21"
                                viewBox="0 0 37 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1907_109062)">
                                  <path
                                    d="M8.59129 6.43993L10.3694 8.21815L8.32191 10.2657L6.51442 8.4582C4.11453 11.2531 2.66413 14.8873 2.66413 18.8603H0.279297C0.279297 13.7905 2.33444 9.20036 5.65701 5.87771C8.97973 2.55514 13.5698 0.5 18.6397 0.5C22.6169 0.5 26.299 1.765 29.3055 3.91438L27.3918 5.49344C25.2577 4.09332 22.7681 3.19043 20.0875 2.94967V5.03436H17.1917V2.94967C13.9481 3.24114 10.984 4.50184 8.59129 6.43993ZM17.0133 16.3402C14.223 18.6454 17.955 22.5255 20.4729 19.2225L31.8489 5.02718L31.3163 4.53762L17.0133 16.3402ZM32.589 6.92232C35.3387 10.1323 37 14.3024 37 18.8603H34.6151C34.6151 15.057 33.2861 11.5642 31.0674 8.82096L32.589 6.92232Z"
                                    fill="#6A6572"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1907_109062">
                                    <rect
                                      width="36.7207"
                                      height="20"
                                      fill="white"
                                      transform="translate(0.279297 0.5)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="dt-text">{item?.score}</span>
                            </div>
                          </div>
                          <div
                            className="d-flex grow-1 align-items-start gap-3 justify-content-between"
                            title={item?.office}
                          >
                            <div className="dt-icons w-100">
                              <svg
                                width="23"
                                height="21"
                                viewBox="0 0 23 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_1907_109058)">
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M9.29822 14.5576C8.96835 16.0693 8.24248 17.4662 7.19498 18.6051C6.66552 19.187 6.05721 19.692 5.38776 20.1053C5.28527 20.1814 5.16208 20.2246 5.0345 20.2292C4.90692 20.2337 4.78096 20.1995 4.67328 20.1309C3.7091 19.5237 2.8531 18.7597 2.14062 17.8705C1.26072 16.7984 0.670006 15.5188 0.424766 14.1537C0.214624 12.8563 0.413802 11.6028 1.07529 10.5777C1.34355 10.1596 1.67949 9.78908 2.06935 9.48127C2.91469 8.77689 3.97686 8.38519 5.07712 8.37209C6.15468 8.38657 7.18732 8.80603 7.96976 9.54705C8.27362 9.82172 8.5364 10.1387 8.75003 10.4881C9.44624 11.6393 9.60156 13.0939 9.29822 14.5576ZM7.83637 19.8732H22.1826V6.36935H16.5234V19.8696H15.8967V1.12677H6.3471V7.19347H6.327H6.31787H6.28863H6.27949H6.24112H6.23016H6.21188H6.19178H6.16255H6.15158H5.72033V3.78917V1.0482C5.72095 0.903489 5.77875 0.764893 5.88114 0.662633C5.93206 0.611165 5.99267 0.570295 6.05948 0.542381C6.12628 0.514468 6.19796 0.500064 6.27036 0.500002H15.9734C16.0457 0.499825 16.1173 0.513941 16.1841 0.541538C16.2509 0.569135 16.3116 0.609668 16.3626 0.660806L16.3846 0.686388C16.4742 0.787001 16.5236 0.917103 16.5234 1.05185V5.74258H22.338C22.3982 5.74241 22.4578 5.75428 22.5133 5.7775C22.5689 5.80073 22.6192 5.83483 22.6614 5.8778C22.7044 5.91997 22.7385 5.97031 22.7617 6.02585C22.7849 6.0814 22.7968 6.14103 22.7966 6.20124V20.1857C22.7966 20.2269 22.7885 20.2677 22.7727 20.3057C22.7568 20.3437 22.7337 20.3783 22.7045 20.4073C22.6752 20.4363 22.6406 20.4593 22.6025 20.4749C22.5643 20.4905 22.5235 20.4984 22.4823 20.4982H7.12371L7.13833 20.4854L7.15478 20.4726L7.1694 20.4598L7.18584 20.447L7.19681 20.4379H7.20777H7.21691H7.22787H7.23701H7.24797H7.25894L7.2699 20.4287V20.4196H7.28086H7.29H7.29914L7.3101 20.4105H7.32107H7.33203H7.34117L7.65364 20.0523L7.67374 20.0359H7.6847L7.69384 20.0267L7.70298 20.0176L7.83637 19.8732ZM10.592 11.5626H11.3229C11.3371 11.5626 11.3511 11.5654 11.3642 11.5708C11.3772 11.5762 11.3891 11.5842 11.3991 11.5942C11.4091 11.6042 11.4171 11.6161 11.4225 11.6291C11.4279 11.6422 11.4307 11.6562 11.4307 11.6704V13.4118C11.4302 13.4403 11.4187 13.4674 11.3986 13.4875C11.3785 13.5077 11.3513 13.5192 11.3229 13.5196H10.7601C10.7809 13.0773 10.7625 12.634 10.7053 12.1948C10.6778 11.9847 10.6395 11.7764 10.592 11.5717V11.5626ZM10.5189 15.1642H11.3192C11.3475 15.1647 11.3745 15.1763 11.3943 15.1964C11.4141 15.2166 11.4252 15.2438 11.4252 15.272V17.0135C11.4255 17.0275 11.4229 17.0415 11.4177 17.0546C11.4125 17.0677 11.4047 17.0796 11.3948 17.0896C11.385 17.0996 11.3732 17.1076 11.3602 17.1131C11.3472 17.1185 11.3333 17.1213 11.3192 17.1213H9.80256C10.1109 16.4966 10.3511 15.8404 10.5189 15.1642ZM9.60521 7.96094H11.3229C11.351 7.96094 11.378 7.97211 11.3978 7.99198C11.4177 8.01186 11.4289 8.03882 11.4289 8.06693V9.80836C11.4291 9.82243 11.4266 9.83641 11.4213 9.84948C11.4161 9.86255 11.4084 9.87445 11.3985 9.88449C11.3886 9.89452 11.3769 9.90249 11.3639 9.90793C11.3509 9.91337 11.337 9.91617 11.3229 9.91617H9.9524L9.88297 9.79922C9.76496 9.60345 9.63625 9.41434 9.4974 9.23276V8.06693C9.4974 8.05285 9.5002 8.03892 9.50564 8.02594C9.51108 8.01296 9.51905 8.0012 9.52909 7.99133C9.53912 7.98146 9.55102 7.9737 9.56409 7.96848C9.57716 7.96326 9.59114 7.9607 9.60521 7.96094ZM12.7117 15.1642H14.4147C14.443 15.1647 14.4699 15.1763 14.4898 15.1964C14.5096 15.2166 14.5207 15.2438 14.5207 15.272V17.0135C14.522 17.0281 14.5202 17.0429 14.5154 17.0568C14.5107 17.0708 14.5031 17.0836 14.4931 17.0944C14.4831 17.1052 14.471 17.1139 14.4575 17.1198C14.444 17.1256 14.4294 17.1287 14.4147 17.1286H12.697C12.6828 17.1288 12.6687 17.1262 12.6555 17.1209C12.6423 17.1156 12.6303 17.1076 12.6202 17.0976C12.6102 17.0875 12.6023 17.0755 12.5969 17.0623C12.5916 17.0491 12.589 17.035 12.5892 17.0208V15.272C12.5892 15.2434 12.6006 15.216 12.6208 15.1958C12.641 15.1756 12.6684 15.1642 12.697 15.1642H12.7117ZM12.7117 11.5626H14.4147C14.4288 11.5626 14.4427 11.5654 14.4557 11.5708C14.4687 11.5763 14.4804 11.5842 14.4903 11.5943C14.5002 11.6043 14.5079 11.6162 14.5132 11.6293C14.5184 11.6423 14.5209 11.6563 14.5207 11.6704V13.4118C14.5207 13.4401 14.5096 13.4673 14.4898 13.4874C14.4699 13.5076 14.443 13.5192 14.4147 13.5196H12.697C12.6684 13.5196 12.641 13.5083 12.6208 13.4881C12.6006 13.4678 12.5892 13.4404 12.5892 13.4118V11.6704C12.589 11.6562 12.5916 11.642 12.5969 11.6288C12.6023 11.6157 12.6102 11.6037 12.6202 11.5936C12.6303 11.5836 12.6423 11.5756 12.6555 11.5703C12.6687 11.565 12.6828 11.5623 12.697 11.5626H12.7117ZM12.7117 7.96094H14.4147C14.4428 7.96094 14.4698 7.97211 14.4897 7.99198C14.5095 8.01186 14.5207 8.03882 14.5207 8.06693V9.80836C14.5209 9.82243 14.5184 9.83641 14.5132 9.84948C14.5079 9.86255 14.5002 9.87445 14.4903 9.88449C14.4804 9.89452 14.4687 9.90249 14.4557 9.90793C14.4427 9.91337 14.4288 9.91617 14.4147 9.91617H12.697C12.6828 9.91642 12.6687 9.9138 12.6555 9.90847C12.6423 9.90314 12.6303 9.89521 12.6202 9.88515C12.6102 9.87509 12.6023 9.8631 12.5969 9.84991C12.5916 9.83672 12.589 9.82259 12.5892 9.80836V8.06693C12.5892 8.05285 12.592 8.03892 12.5975 8.02594C12.6029 8.01296 12.6109 8.0012 12.6209 7.99133C12.6309 7.98146 12.6428 7.9737 12.6559 7.96848C12.669 7.96326 12.683 7.9607 12.697 7.96094H12.7117ZM18.1936 13.5471H20.6788C20.708 13.5471 20.7318 13.5653 20.7318 13.5836V14.6051C20.7318 14.6233 20.7043 14.6434 20.6788 14.6434H18.179C18.1534 14.6434 18.126 14.6252 18.126 14.6051V13.5836C18.126 13.5635 18.1498 13.5471 18.179 13.5471H18.1936ZM7.75049 2.48995H14.4933C14.5597 2.49042 14.6233 2.51689 14.6704 2.56369C14.7176 2.61048 14.7445 2.67388 14.7455 2.74029V5.40635C14.7445 5.47277 14.7176 5.53616 14.6704 5.58296C14.6233 5.62975 14.5597 5.65622 14.4933 5.65669H7.75049C7.68407 5.65622 7.62047 5.62975 7.57334 5.58296C7.5262 5.53616 7.49927 5.47277 7.49832 5.40635V2.74029C7.4988 2.67373 7.52558 2.61006 7.57282 2.56316C7.62006 2.51627 7.68392 2.48995 7.75049 2.48995ZM18.179 11.3122H20.6641C20.6934 11.3122 20.7171 11.3323 20.7171 11.3506V12.3776C20.7171 12.3958 20.6897 12.4159 20.6641 12.4159H18.179C18.1534 12.4159 18.126 12.3977 18.126 12.3776V11.3506C18.126 11.3287 18.1498 11.3122 18.179 11.3122ZM18.179 9.0884H20.6641C20.6934 9.0884 20.7171 9.1085 20.7171 9.12677V10.1464C20.7171 10.1647 20.6897 10.1848 20.6641 10.1848H18.179C18.1534 10.1848 18.126 10.1683 18.126 10.1464V9.11763C18.126 9.09571 18.1498 9.07926 18.179 9.07926V9.0884ZM4.89073 10.8956C5.30101 10.8953 5.70218 11.0166 6.04349 11.2443C6.38479 11.4719 6.65091 11.7957 6.80817 12.1747C6.96542 12.5536 7.00676 12.9707 6.92694 13.3731C6.84712 13.7756 6.64973 14.1453 6.35975 14.4355C6.06977 14.7258 5.70022 14.9235 5.29785 15.0036C4.89548 15.0838 4.47838 15.0429 4.09929 14.8859C3.72021 14.729 3.39619 14.4632 3.16821 14.1221C2.94024 13.781 2.81855 13.3799 2.81855 12.9696C2.81855 12.4199 3.03681 11.8926 3.42537 11.5037C3.81393 11.1148 4.34099 10.8961 4.89073 10.8956Z"
                                    fill="#6A6572"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1907_109058">
                                    <rect
                                      width="22.4541"
                                      height="20"
                                      fill="white"
                                      transform="translate(0.344238 0.5)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span className="dt-text dt-office">
                                {item?.office}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  );
                })}
              </div>
            ) : (
              <div className="col-md-12 notf-ound">
                <div className="not-found mt-3">
                  <div className="interboxes">
                    <img src="/images/telescope.svg" alt="Not Found" />
                    <p>No leaderboard data yet.</p>
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-12">
                <div className="responsive-carousel-points-table">
                  <div className="course-info-table">
                    {leaderBoardData.length > 3 && (
                      <table className="table mb-0 office_list table-striped video-list">
                        <thead className="position-relative">
                          <tr>
                            <th
                              className="text-rank"
                              scope="col"
                              style={{ Width: "100px" }}
                            >
                              Ranking
                            </th>
                            <th
                              className="text-naem"
                              scope="col"
                              style={{ minWidth: "300px" }}
                            >
                              Name
                            </th>
                            {false && (
                              <th
                                className="text-role"
                                scope="col"
                                style={{ minWidth: "200px" }}
                              >
                                Role
                              </th>
                            )}
                            <th
                              className="text-left"
                              scope="col"
                              style={{ minWidth: "200px" }}
                            >
                              Office
                            </th>
                            <th
                              className="text-left"
                              scope="col"
                              style={{ minWidth: "200px" }}
                            >
                              Learning points
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {leaderBoardData.length > 0 ? (
                            leaderBoardData.map((item, index) => {
                              return index < 3 ? (
                                ""
                              ) : (
                                <tr
                                  key={`lp-${1}`}
                                  className={item.is_me && "my-position"}
                                >
                                  <td>{item?.rank}</td>
                                  <td className="text-name">
                                    <div className="d-flex gap-2 names-hw align-items-start">
                                      <img
                                        src={
                                          _.isEmpty(item?.profile)
                                            ? "/images/avatar.png"
                                            : item?.profile
                                        }
                                        width={24}
                                        height={24}
                                      />
                                      <div className="name-sse">
                                        {item?.name}
                                      </div>
                                    </div>
                                  </td>
                                  {false && (
                                    <td className="text-date">
                                      {item?.role ? item?.role : "-"}
                                    </td>
                                  )}
                                  <td className="text-left">{item?.office}</td>
                                  <td className="text-left">{item?.score}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr className="not-found">
                              <td colSpan={5}>
                                <img
                                  src="/images/telescope.svg"
                                  alt="Not Found"
                                />
                                <p>No leaderboard data yet.</p>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LeaderBoardComp;
